import { ActionTypes } from "../constants/action-types";

const initialState = {
    SponsorImageStaus:[],
};

export const UploadSponsorImage = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.UPLOAD_SPONSOR_IMAGE:
      return { ...state, SponsorImageStaus: payload };
    default:
      return state;
  }
};